import { Form as FormikForm } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface FormProps {
  isEdition?: boolean;
}

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1300px;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ theme }) => theme.group.whiteGrey};
    height: 100%;
    max-width: none;
  }
`;

export const Scaffold = styled.section`
  background-color: ${({ theme }) => theme.group.white};

  @media ${({ theme }) => theme.device.desktop} {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  @media ${({ theme }) => theme.device.mobile} {
    height: 100%;
    max-width: none;
  }
`;

export const Form = styled(FormikForm)<FormProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ isEdition }) => isEdition && '100px'};
`;

export const Fields = styled.div`
  flex: 1;
`;

export const Warning = styled.div`
  color: ${ColorPalette.HEX.DimGray};
  font-size: 14px;
`;

export const Section = styled.section`
  padding: 32px 0 48px 0;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 32px;

    padding-left: 0;
    padding-right: 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 20px 16px 32px 16px;
  }
`;

export const Title = styled.h3`
  font-weight: 600;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.title};
`;

export const Details = styled.p`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.group.section.details};
  & strong {
    font-weight: 600;
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
`;
